import { observer } from 'mobx-react-lite'
import { Box, Divider, Switch, Typography } from 'shared/ui'
import { LINK_AUTO_REMINDERS_LEARN_MORE } from 'shared/constants/links'
import { AutoFollowUp } from 'pages/chatbot/ui/FollowUpSettings/AutoFollowUp'
import { DaysDropdown } from 'pages/chatbot/ui/FollowUpSettings/DaysDropdown'
import { useUnifiedAgentContext } from 'pages/chatbot/ui/UnifiedAgent/context/unifiedAgentContext'
import styles from './styles.module.scss'

export const AutoFollowUpSection = observer(() => {
  const {
    autoFollowUpSectionStore: {
      enabled,
      sessionLifetime,
      setSessionLifetime,
      setAssertiveness,
      setFollowUpWindow,
      setEnabled,
      followUpWindow,
      assertiveness,
    },
  } = useUnifiedAgentContext()

  return (
    <>
      <Box display={'flex'}>
        <Box display={'flex'} flexDirection={'column'} flexGrow={'1'}>
          <Typography variant={'body-lg-medium'} ariaLabel={'AutoFollowUp'}>
            Auto Follow-Up™
          </Typography>
          <Typography
            variant={'body-md-regular'}
            ariaLabel={'AutoFollowUpDesc'}
            color={'var(--content-primary-secondary)'}
            marginTop={4}
            marginBottom={enabled ? 12 : 0}
          >
            AI-powered follow-ups to maximize engagement.{' '}
            <a
              href={LINK_AUTO_REMINDERS_LEARN_MORE}
              target={'_blank'}
              rel='noreferrer'
              className={styles.learnMoreLink}
            >
              Learn more
            </a>
          </Typography>
        </Box>
        <Box paddingTop={'4px'}>
          <Switch value={enabled} onChange={setEnabled} size='middle' />
        </Box>
      </Box>
      {enabled && (
        <AutoFollowUp
          followUpWindow={followUpWindow}
          followUpAssertiveness={assertiveness}
          setFollowUpWindow={setFollowUpWindow}
          setFollowUpAssertiveness={setAssertiveness}
        />
      )}
      <Divider style={{ margin: '24px 0' }} />
      <Typography variant={'body-lg-medium'} ariaLabel={'EndSession'}>
        End session
      </Typography>
      {enabled ? (
        <Typography
          variant={'body-md-regular'}
          ariaLabel={'EndSessionDesc'}
          color={'var(--content-primary-secondary)'}
          marginTop={4}
          tag='div'
        >
          If the contact doesn&apos;t reply within 1 day after the follow-up window
        </Typography>
      ) : (
        <DaysDropdown
          label={"If the contact doesn't reply within"}
          followUpWindow={sessionLifetime}
          setFollowUpWindow={setSessionLifetime}
          days={Array(30)
            .fill(0)
            .map((_, index) => ({
              value: index + 1,
              label: String(index + 1),
            }))}
          className={styles.sessionLifetime}
        />
      )}
    </>
  )
})
